/**
 * Provides an interface to the user to listen on the WriteDocs status. It also dispatches 
 * redux action to notify about it's status change.
 * 
 * Note: When `localWrite` is rejected, `remoteWrite` will neither  be resolved nor be rejected. In this case,
 * remoteWrite is simply skipped.
 * As of now, `localWrite` can be rejected only in the case when local database doesn't exist yet.
 */

 import { uuid } from "@dreamworld/uuid-base62";
import {
  writeDocsLocalCompleted,
  writeDocsLocalFailed,
  writeDocsRemoteCompleted,
  writeDocsRemoteFailed
} from "./redux/actions.js";

//lodash
import keyBy from "lodash-es/keyBy";

export default class WriteDocsResponse {

  constructor(couchdbName, dbName, dispatch) {
    this.id = uuid();
    this.couchdbName = couchdbName;
    this.dbName = dbName;
    this.dispatch = dispatch;
    this.requestedAt = new Date().getTime();

    this.localWrite = new Promise((resolve, reject) => {
      this._localWriteResolve = resolve;
      this._localWriteReject = reject;
    });

    this.remoteWrite = new Promise((resolve, reject) => {
      this._remoteWriteResolve = resolve;
      this._remoteWriteReject = reject;
    });
  }

  /**
   * It will used by database.
   * It will resolve localWrite promise 
   * @param {Object} response 
   */
  _resolveLocalWrite(response, successDocsWithRevs, requestedAt) {
    this._localWriteResolve(response);

    //Dispatch Redux action
    this.dispatch(writeDocsLocalCompleted({
      couchdbName: this.couchdbName,
      dbName: this.dbName,
      requestedAt,
      docs: keyBy(successDocsWithRevs, '_id')
    }));
  }

  /**
   * It will used by database.
   * It will reject localWrite promise 
   * @param {Object} response 
   */
  _rejectLocalWrite(error, reqDocs, failedDocs) {
    this._localWriteReject(error);

    //Dispatch Redux action
    this.dispatch(writeDocsLocalFailed({
      couchdbName: this.couchdbName,
      dbName: this.dbName,
      reqDocs,
      error
    }));
  }

  /**
   * It will used by database.
   * It will resolve remoteWrite promise 
   * @param {Object} response 
   */
  _resolveRemoteWrite(reqDocs, response) {
    this._remoteWriteResolve(response);

    //Dispatch Redux action
    this.dispatch(writeDocsRemoteCompleted({
      couchdbName: this.couchdbName,
      dbName: this.dbName,
      reqDocs,
      failedWrites: keyBy(response || [], 'id')
    }));
  }

  /**
   * It will used by database.
   * It will reject remoteWrite promise 
   * @param {Object} response 
   */
  _rejectRemoteWrite(reqDocs, response) {
    this._remoteWriteReject(response.error);

    //Dispatch Redux action
    this.dispatch(writeDocsRemoteFailed({
      couchdbName: this.couchdbName,
      dbName: this.dbName,
      reqDocs,
      error: response.error
    }));
  }

}